export enum AccionesRntType {
	Inscripcion = 'solicitudes/inscripcion',
	Renovacion = 'solicitudes/renovacion',
	Suspension = 'otra-solicitudes/suspension',
	Cancelacion = 'otra-solicitudes/cancelacion',
	Reactivacion = 'otra-solicitudes/reactivacion',
	// Edicion = 'solicitud/completa-informacion-guia',
	Edicion = 'solicitud/actualizacion',
	ExpedirCertificado = 'expedir-certificado',
	ReporteInscripcion = 'reporte-inscripcion',
	Arrendatario = 'arrendatario',
	Notificaciones = 'notificacion',
	DetalleSolicitud = 'detalle-solicitud',
	Vehiculos = 'vehiculos',
	Anotacion = 'anotacion',
	ReactivacionAnticipada = 'reactivacion-anticipada',
	ReactivacionRenovacion = 'otra-solicitudes/reactivacion',
  	Eliminacion = 'eliminar-solicitud'
}
